module.exports = __webpack_public_path__ + "resources/img/img_experdb_jp.71c39eec937ac0d180d925d3adf94b0e.png";